module.exports = __webpack_public_path__ + "static/media/platform-android.523962ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/platform-android.svg
// module id = 677
// module chunks = 0